export default "__VITE_ASSET__CkyxTbP3__"